import { Injectable } from "@nestjs/common"
import { InjectRepository } from "@nestjs/typeorm"
import { DataSource, Repository } from "typeorm"
import {  VehicleCategoryEntity } from "./vehicle-category.entity"
import { CommonResponseModel, VehcileCategoryDto } from "@project-management-system/shared-models"
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object"
import { VehicleCategoryDto } from "./vehicle-category.dto"


@Injectable()
export class VehicleCategoryService {
    constructor(
        @InjectRepository(VehicleCategoryEntity)

        private repo: Repository<VehicleCategoryEntity>,
        private readonly dataSource: DataSource,

    ) { }

    async createVehicleCategory(req?: VehcileCategoryDto,isUpdate?:boolean) : Promise<CommonResponseModel>{
        try{
            const entity = new VehicleCategoryEntity()
            if(!isUpdate){
                const ColumnCheck = await this.repo.find({where:{vehicleCategory:req.vehicleCategory}})
                if(ColumnCheck.length >0){
                    return new CommonResponseModel(false,0,'VehicleCategory already exists')
                }
            }
            entity.vehicleCategory = req.vehicleCategory;
            if(isUpdate){
                entity.id = req.id;
                entity.updatedUser = req.createdUser
            } else{
                entity.createdUser = req.createdUser
            }
            const save = await this.repo.save(entity)
            return new CommonResponseModel(true,1,isUpdate ? 'Column Updated successfully' : 'Column Saved successfully',save)

        } catch(err){
            throw err
        }
    }

    async getAllVehicleCategory():Promise<CommonResponseModel>{
        try{
            const data = await this.repo.find({order:{'vehicleCategory':'ASC'}})
            let info = []
            if(data.length > 0){
                for(const rec of data){
                    info.push(new VehcileCategoryDto(rec.id,rec.vehicleCategory,rec.isActive,rec.updatedUser,rec.createdUser,rec.versionFlag,))
                }
                return new CommonResponseModel(true,1,'Data retrieved',info)
            } else{
                return new CommonResponseModel(false,0,'No data found',info)
            }

        } catch(err){
            throw err
        }
   }

    async getActiveAllVehcileCategory(): Promise<CommonResponseModel> {
        const data = await this.repo.find({
            where: {
                isActive: true
            },
            order:{"vehicleCategory":"ASC"}
        })

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    }


    async updateVehicleCategory(req: VehcileCategoryDto): Promise<CommonResponseModel> {

        try {
            let Product;
            Product = await this.repo.update(
                { id: req.id },
                {
                    vehicleCategory: req.vehicleCategory,
                }
            )
            if (Product.affected > 0) {
                return new CommonResponseModel(true, 11, 'updated successfully', Product);
            }
            else {
                return new CommonResponseModel(false, 11, 'uploaded failed', []);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivateVehicleCategory(req: VehcileCategoryDto): Promise<CommonResponseModel> {
        try {
            console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current VehicleCategory information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'VehicleCategory is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'VehicleCategory is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'VehicleCategory is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'VehicleCategory is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }




}